import { PremiumElement } from '../../../types/PremiumElement';
import {
    HalvCoveragesIds,
    HelCoveragesIds,
    PlusCoveragesIds,
    TillagsAllRiskCoverageIds,
    TillagsHyrbilCoverageIds,
    TrafikCoveragesIds
} from '../../../types/enums/products/companyCar/coverages';
import { PaymentTerms } from '../../../types/enums/PaymentTerms';
import { preparePrice } from '../calculation-data-service';

export const prepareTrafikPrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms
): number | string => {
    return preparePrice(premiumList, paymentTerm, 10000, TrafikCoveragesIds);
};

export const prepareHalvPrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms
): number | string => {
    return preparePrice(premiumList, paymentTerm, 15000, HalvCoveragesIds);
};

export const prepareHelPrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms
): number | string => {
    return preparePrice(premiumList, paymentTerm, 20000, HelCoveragesIds);
};

export const preparePlusPackagePrice = (
    premiumList: PremiumElement[]
): number | string => {
    return preparePrice(premiumList, null, null, PlusCoveragesIds);
};

export const prepareTillagsHyrbilPrice = (
    premiumList: PremiumElement[]
): number | string => {
    return preparePrice(premiumList, null, null, TillagsHyrbilCoverageIds);
};

export const prepareTillagsAllRiskPrice = (
    premiumList: PremiumElement[]
): number | string => {
    return preparePrice(premiumList, null, null, TillagsAllRiskCoverageIds);
};
